<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'computer-settle-in'
}
</script>

<style></style>
